import { KibCareTeamIcon } from '@chewy/kib-icons-react';

/**
 * Maps payload action strings to Chirp icons. Use only icons that are exported
 * from `@chewy/kib-icons-react` for your pinned version — named imports that do
 * not exist resolve to `undefined` and will crash at runtime when rendered.
 */
export const getIconByActionType = (actionType: string) => {
    if (!actionType) {
        return undefined;
    }

    switch (actionType) {
        case 'CONTACT_CARE_TEAM':
        case 'CONNECT_TO_AGENT':
            return <KibCareTeamIcon />;
        default:
            return undefined;
    }
};
